import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39.14 45.092a3 3 0 0 0 .86-2.103v-5.648a7 7 0 0 0 5.632-6.25c.245-2.759.368-5.777.368-9.055 0-2.642-.08-4.958-.24-6.95a7 7 0 0 0-6.477-6.422c-5.847-.419-10.919-.628-15.218-.628-4.31 0-9.425.21-15.344.63a7 7 0 0 0-6.482 6.424C2.08 17.08 2 19.396 2 22.036c0 3.274.122 6.288.367 9.043a7 7 0 0 0 6.47 6.362c5.177.373 10.288.559 15.333.559 1.148 0 2.296-.01 3.444-.029l7.283 7.158a3 3 0 0 0 4.243-.037ZM14.586 22.586a2 2 0 1 0 2.828 2.828 2 2 0 0 0-2.828-2.828Zm16 2.828a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828Zm-8-2.828a2 2 0 1 0 2.828 2.828 2 2 0 0 0-2.828-2.828Z",
      clipRule: "evenodd"
    }
  )
);
var SvgMessageDotsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageDotsFilled_default = SvgMessageDotsFilled;

export { MessageDotsFilled_default as default };
